// Keep an editor registered until its last write completes, including navigation.
const editors = new Set();

export function registerPendingEditor(editor) {
  editors.add(editor);
  return () => editors.delete(editor);
}

export function hasPendingEdits() {
  return [...editors].some((editor) => editor.isDirty());
}

export async function flushPendingEditors() {
  const results = await Promise.allSettled([...editors].map((editor) => editor.flush()));
  return results.every((result) => result.status === "fulfilled") && !hasPendingEdits();
}
